var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { attrs: { flat: "" } },
    [
      _c(
        "v-card-text",
        { staticClass: "install-panel" },
        [
          _c(
            "v-flex",
            [
              _c(
                "v-stepper",
                {
                  model: {
                    value: _vm.stepIndex,
                    callback: function ($$v) {
                      _vm.stepIndex = $$v
                    },
                    expression: "stepIndex",
                  },
                },
                [
                  _c(
                    "v-stepper-header",
                    {
                      staticStyle: {
                        width: "90%",
                        "margin-left": "auto",
                        "margin-right": "auto",
                      },
                    },
                    [
                      _vm._l(_vm.steps, function (step, index) {
                        return [
                          _c(
                            "v-stepper-step",
                            { key: index, attrs: { step: step.index } },
                            [_vm._v(_vm._s(step.title))]
                          ),
                          _vm._v(" "),
                          step.next
                            ? _c("v-divider", { key: index + "d" })
                            : _vm._e(),
                        ]
                      }),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "v-stepper-items",
                    _vm._l(_vm.steps, function (step, index) {
                      return _c(
                        "v-stepper-content",
                        { key: index, attrs: { step: step.index } },
                        [
                          step.title === "Checklist"
                            ? _c(
                                "v-layout",
                                {
                                  staticStyle: { "text-align": "center" },
                                  attrs: { wrap: "" },
                                },
                                [
                                  _c("v-flex", { attrs: { xs12: "" } }, [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "font-weight-bold",
                                        staticStyle: { "font-size": "28px" },
                                      },
                                      [
                                        _vm._v(
                                          "Preparing your environment checklist"
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("br"),
                                    _vm._v(" "),
                                    _c("br"),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "body-1" }, [
                                      _vm._v(
                                        "\n                Before you begin setting up, please review the checklist to ensure you've already prepared your environment for the installation.\n                "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("br"),
                                    _vm._v(" "),
                                    _c("br"),
                                    _vm._v(" "),
                                    _c("br"),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    {
                                      staticStyle: { "text-align": "left" },
                                      attrs: { xs6: "" },
                                    },
                                    [
                                      _c(
                                        "v-flex",
                                        { attrs: { "ma-2": "" } },
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { size: "14" } },
                                            [_vm._v("fal fa-check")]
                                          ),
                                          _vm._v("  "),
                                          _c(
                                            "span",
                                            { staticClass: "body-2" },
                                            [
                                              _vm._v(
                                                "1. Prepare a WXP Collaboration Data Collector server instance"
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: { icon: "" },
                                              on: {
                                                click: function ($event) {
                                                  _vm.showChecklist1 =
                                                    !_vm.showChecklist1
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                { attrs: { size: "14" } },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.showChecklist1
                                                        ? "fal fa-chevron-down"
                                                        : "fal fa-chevron-right"
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _vm.showChecklist1
                                            ? _c("div", [
                                                _c("div", [
                                                  _vm._v(
                                                    "A server must be provisioned on which the WXP Collaboration Data Collector will be installed and configured. The Data Collector is used to communicate with your video infrastructure in your internal, and in some cases, external environment. The server can be either a virtual or physical appliance. The server will need network access to your video infrastructure and will always be running."
                                                  ),
                                                ]),
                                              ])
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { "ma-2": "" } },
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { size: "14" } },
                                            [_vm._v("fal fa-check")]
                                          ),
                                          _vm._v("  "),
                                          _c(
                                            "span",
                                            { staticClass: "body-2" },
                                            [
                                              _vm._v(
                                                "2. Test the connection to the WXP Collaboration Cloud"
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: { icon: "" },
                                              on: {
                                                click: function ($event) {
                                                  _vm.showChecklist2 =
                                                    !_vm.showChecklist2
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                { attrs: { size: "14" } },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.showChecklist2
                                                        ? "fal fa-chevron-down"
                                                        : "fal fa-chevron-right"
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _vm.showChecklist2
                                            ? _c("div", [
                                                _c("div", [
                                                  _vm._v(
                                                    "It is important to test the connection to WXP Collaboration�s Cloud on the VM or server provisioned. To test the connection to the WXP Collaboration Cloud, the Administrator must ensure https connectivity to WXP Collaboration Cloud Servers."
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  { staticClass: "mt-2" },
                                                  [
                                                    _c(
                                                      "a",
                                                      {
                                                        attrs: {
                                                          href: _vm.brandingService.getSupportUrl(
                                                            "urlRequirements"
                                                          ),
                                                          target: "_blank",
                                                        },
                                                      },
                                                      [_vm._v("More details")]
                                                    ),
                                                    _vm._v(
                                                      " on URL requirements for the WXP Collaboration product"
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  { staticClass: "mt-5" },
                                                  [
                                                    _c("h2", [
                                                      _vm._v(
                                                        "Please perform the following tests from Remote Desktop (RDP) on the WXP Collaboration Data Collector Server:"
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  { staticClass: "mt-4" },
                                                  [
                                                    _c("ol", [
                                                      _c("li", [
                                                        _vm._v("Navigate to "),
                                                        _c(
                                                          "a",
                                                          {
                                                            attrs: {
                                                              href: "https://login.vyopta.com/auth/",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "https://login.vyopta.com/auth/"
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(
                                                          " and confirm that you see the WXP Collaboration logo"
                                                        ),
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("li", [
                                                        _vm._v("Navigate to "),
                                                        _c(
                                                          "a",
                                                          {
                                                            attrs: {
                                                              href: "https://api.vyopta.com/auth/",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "https://api.vyopta.com/auth/"
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(
                                                          " and confirm that you see the WXP Collaboration logo"
                                                        ),
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("li", [
                                                        _vm._v("Navigate to "),
                                                        _c(
                                                          "a",
                                                          {
                                                            attrs: {
                                                              href: "https://galaxy-admin-mq.vyopta.com",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "https://galaxy-admin-mq.vyopta.com/"
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(
                                                          " and confirm that you see an API response - HTTP 400 Error with No clientID header specified."
                                                        ),
                                                      ]),
                                                    ]),
                                                  ]
                                                ),
                                              ])
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { "ma-2": "" } },
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { size: "14" } },
                                            [_vm._v("fal fa-check")]
                                          ),
                                          _vm._v("  "),
                                          _c(
                                            "span",
                                            { staticClass: "body-2" },
                                            [
                                              _vm._v(
                                                "3. Reviewed the recommended specs"
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: { icon: "" },
                                              on: {
                                                click: function ($event) {
                                                  _vm.showChecklist3 =
                                                    !_vm.showChecklist3
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                { attrs: { size: "14" } },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.showChecklist3
                                                        ? "fal fa-chevron-down"
                                                        : "fal fa-chevron-right"
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _vm.showChecklist3
                                            ? _c("div", [
                                                _c(
                                                  "table",
                                                  { staticClass: "mt-4" },
                                                  [
                                                    _c("tr", [
                                                      _c("td", [
                                                        _c("strong", [
                                                          _vm._v("CPU"),
                                                        ]),
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("td", [
                                                        _vm._v(
                                                          "Dual CPUs (2.4GHz or higher)"
                                                        ),
                                                      ]),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("tr", [
                                                      _c("td", [
                                                        _c("strong", [
                                                          _vm._v("Memory"),
                                                        ]),
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("td", [
                                                        _vm._v("8GB RAM"),
                                                      ]),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("tr", [
                                                      _c("td", [
                                                        _c("strong", [
                                                          _vm._v("Storage"),
                                                        ]),
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("td", [
                                                        _vm._v(
                                                          "80GB disk space (OS and Data)"
                                                        ),
                                                      ]),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("tr", [
                                                      _c("td", [
                                                        _c("strong", [
                                                          _vm._v("Network"),
                                                        ]),
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("td", [
                                                        _vm._v("1 Gbps NIC"),
                                                      ]),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("tr", [
                                                      _c("td", [
                                                        _c("strong", [
                                                          _vm._v(
                                                            "Server Operating System"
                                                          ),
                                                        ]),
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("td", [
                                                        _vm._v(
                                                          "Windows Server (2012 R2, 2016, 2019) CentOS 7/6+ or RHEL 7/6+"
                                                        ),
                                                      ]),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("tr", [
                                                      _c("td", [
                                                        _c("strong", [
                                                          _vm._v("Java"),
                                                        ]),
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("td", [
                                                        _vm._v(
                                                          "Java 11 (bundled with installer)"
                                                        ),
                                                      ]),
                                                    ]),
                                                  ]
                                                ),
                                              ])
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("v-flex", { attrs: { xs12: "" } }, [
                                    _c(
                                      "div",
                                      { staticClass: "mt-5" },
                                      [
                                        _c("v-checkbox", {
                                          staticClass: "checkbox",
                                          attrs: {
                                            label:
                                              "I have prepared my environment",
                                          },
                                          model: {
                                            value: _vm.collabConnection,
                                            callback: function ($$v) {
                                              _vm.collabConnection = $$v
                                            },
                                            expression: "collabConnection",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "button",
                                          {
                                            staticClass: "btn btn-primary",
                                            attrs: {
                                              disabled: !_vm.collabConnection,
                                            },
                                            on: {
                                              click: function ($event) {
                                                _vm.goNext(step)
                                                _vm.collabConnection = false
                                              },
                                            },
                                          },
                                          [_vm._v("Continue")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          step.title === "License"
                            ? _c(
                                "v-layout",
                                {
                                  staticStyle: { "text-align": "center" },
                                  attrs: { wrap: "" },
                                },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      staticStyle: {
                                        "text-align": "center",
                                        "margin-bottom": "20px",
                                      },
                                      attrs: { xs12: "" },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "font-weight-bold",
                                          staticStyle: { "font-size": "28px" },
                                        },
                                        [_vm._v("License")]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    {
                                      staticStyle: { "text-align": "left" },
                                      attrs: { xs6: "" },
                                    },
                                    [
                                      _c(
                                        "v-flex",
                                        { attrs: { "min-height": "200px" } },
                                        [
                                          _c("h2", [
                                            _vm._v(
                                              "Accept HP and OpenJDK 11 (GPLv2) License"
                                            ),
                                          ]),
                                          _vm._v(
                                            "\n              (Please note that WXP Collaboration Collector uses OpenJDK for Java 11 runtime platform, which is\n              covered under "
                                          ),
                                          _c(
                                            "a",
                                            {
                                              attrs: {
                                                target: "_blank",
                                                href: "http://openjdk.java.net/legal/gplv2+ce.html",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n              GPLv2 license agreement and related licenses"
                                              ),
                                            ]
                                          ),
                                          _vm._v(")\n              "),
                                          _c("p"),
                                          _vm._v(
                                            "\n              You must accept the\n                "
                                          ),
                                          _c(
                                            "v-tooltip",
                                            {
                                              attrs: { bottom: "" },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "activator",
                                                    fn: function ({ on }) {
                                                      return [
                                                        _c(
                                                          "a",
                                                          {
                                                            attrs: {
                                                              target: "_blank",
                                                              href: "https://support.hp.com/us-en/document/ish_4416646-4390016-16",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "License Agreement"
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            },
                                            [
                                              _vm._v(
                                                "\n                    Opens in new window\n                "
                                              ),
                                            ]
                                          ),
                                          _vm._v(
                                            " to continue.\n                "
                                          ),
                                          _c(
                                            "v-checkbox",
                                            {
                                              model: {
                                                value: _vm.eulaAccepted,
                                                callback: function ($$v) {
                                                  _vm.eulaAccepted = $$v
                                                },
                                                expression: "eulaAccepted",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  attrs: { slot: "label" },
                                                  slot: "label",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    I Accept the OpenJDK and WXP Collaboration License Agreements\n                "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "button",
                                            {
                                              staticClass: "btn btn-default",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.goPrev(step)
                                                },
                                              },
                                            },
                                            [_vm._v("Back")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "button",
                                            {
                                              staticClass: "btn btn-primary",
                                              attrs: {
                                                disabled: !_vm.eulaAccepted,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  _vm.goNext(step)
                                                  _vm.eulaAccepted = false
                                                },
                                              },
                                            },
                                            [_vm._v("Continue")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          step.title === "Service Account"
                            ? _c(
                                "v-layout",
                                {
                                  staticStyle: {
                                    "text-align": "center",
                                    "justify-content": "center",
                                  },
                                  attrs: { wrap: "" },
                                },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      staticStyle: {
                                        "text-align": "center",
                                        "margin-bottom": "10px",
                                      },
                                      attrs: { xs12: "" },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "font-weight-bold",
                                          staticStyle: { "font-size": "28px" },
                                        },
                                        [_vm._v("Service Account")]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    {
                                      staticStyle: { "text-align": "left" },
                                      attrs: { xs8: "" },
                                    },
                                    [
                                      _c(
                                        "v-flex",
                                        { attrs: { xs12: "" } },
                                        [
                                          _c("h2", [
                                            _vm._v(
                                              "The data collector requires to login to the WXP Collaboration Cloud with a service account."
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _vm.allUsers && _vm.allUsers.length
                                            ? _c("v-checkbox", {
                                                attrs: {
                                                  label:
                                                    "Use an existing service account",
                                                },
                                                model: {
                                                  value: _vm.existingUser,
                                                  callback: function ($$v) {
                                                    _vm.existingUser = $$v
                                                  },
                                                  expression: "existingUser",
                                                },
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          !_vm.existingUser
                                            ? _c(
                                                "div",
                                                [
                                                  _c("create-user", {
                                                    on: {
                                                      success: (login) =>
                                                        _vm.userSuccess(
                                                          login,
                                                          step
                                                        ),
                                                    },
                                                  }),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "button",
                                        {
                                          staticClass: "btn btn-default",
                                          on: {
                                            click: function ($event) {
                                              return _vm.goPrev(step)
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                Back\n              "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "button",
                                        {
                                          staticClass: "btn btn-primary",
                                          attrs: {
                                            disabled: !_vm.continueUser,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.goNext(step)
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                Continue\n              "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          step.title === "Configuration"
                            ? _c(
                                "v-layout",
                                {
                                  staticStyle: {
                                    "text-align": "center",
                                    "justify-content": "center",
                                  },
                                  attrs: { wrap: "" },
                                },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      staticStyle: {
                                        "text-align": "center",
                                        "margin-bottom": "10px",
                                      },
                                      attrs: { xs12: "" },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "font-weight-bold",
                                          staticStyle: { "font-size": "28px" },
                                        },
                                        [_vm._v("Configuration")]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    {
                                      staticStyle: { "text-align": "left" },
                                      attrs: { xs8: "" },
                                    },
                                    [
                                      _c(
                                        "v-flex",
                                        { attrs: { xs12: "" } },
                                        [
                                          _c("h2", [
                                            _vm._v(
                                              "The data collector requires a configuration file to be present alongside the collector."
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("v-checkbox", {
                                            attrs: {
                                              label:
                                                "Use an existing vyoptacollector.xml configuration file",
                                            },
                                            model: {
                                              value: _vm.existingConfig,
                                              callback: function ($$v) {
                                                _vm.existingConfig = $$v
                                              },
                                              expression: "existingConfig",
                                            },
                                          }),
                                          _vm._v(" "),
                                          !_vm.existingConfig
                                            ? _c(
                                                "div",
                                                [
                                                  _c("config-file", {
                                                    key: _vm.stepIndex,
                                                    attrs: {
                                                      defaultLogin:
                                                        _vm.serviceAccount,
                                                    },
                                                    on: {
                                                      success: function (
                                                        $event
                                                      ) {
                                                        return _vm.configSuccess(
                                                          step
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "button",
                                        {
                                          staticClass: "btn btn-default",
                                          on: {
                                            click: function ($event) {
                                              return _vm.goPrev(step)
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                Back\n              "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "button",
                                        {
                                          staticClass: "btn btn-primary",
                                          attrs: {
                                            disabled: !_vm.continueConfig,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.goNext(step)
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                Continue\n              "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          step.title === "Download"
                            ? _c(
                                "v-layout",
                                {
                                  staticStyle: { "text-align": "center" },
                                  attrs: { wrap: "" },
                                },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      staticStyle: {
                                        "text-align": "center",
                                        "margin-bottom": "10px",
                                      },
                                      attrs: { xs12: "" },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "font-weight-bold",
                                          staticStyle: { "font-size": "28px" },
                                        },
                                        [_vm._v("Download")]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    {
                                      staticStyle: { "text-align": "center" },
                                      attrs: { xs12: "", "mb-4": "" },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "font-size": "14px",
                                            "font-weight": "bold",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "Download the WXP Collaboration data collector (stable version)"
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    {
                                      staticStyle: { "text-align": "left" },
                                      attrs: { xs8: "" },
                                    },
                                    [
                                      _c("v-flex", { attrs: { xs12: "" } }, [
                                        _c(
                                          "table",
                                          { staticStyle: { padding: "10px" } },
                                          [
                                            _c("thead", [
                                              _c(
                                                "th",
                                                [
                                                  _c("v-icon", [
                                                    _vm._v(
                                                      "fa-brands fa-windows"
                                                    ),
                                                  ]),
                                                  _vm._v(" Windows"),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c("th"),
                                              _vm._v(" "),
                                              _c(
                                                "th",
                                                [
                                                  _c("v-icon", [
                                                    _vm._v(
                                                      "fa-brands fa-linux"
                                                    ),
                                                  ]),
                                                  _vm._v(" Linux"),
                                                ],
                                                1
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c("tbody", [
                                              _c("tr", [
                                                _c("td", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.removeBuild(
                                                          _vm.collectorStableVersion
                                                        )
                                                      )
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("td", [_vm._v("        ")]),
                                                _vm._v(" "),
                                                _c("td", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.removeBuild(
                                                          _vm.collectorStableVersion
                                                        )
                                                      )
                                                  ),
                                                ]),
                                              ]),
                                              _vm._v(" "),
                                              _vm.collectorStableVersion.includes(
                                                ".0."
                                              )
                                                ? _c("tr", [
                                                    _c("td", [
                                                      _c(
                                                        "a",
                                                        {
                                                          attrs: {
                                                            href:
                                                              "/download/api/v1/collector/GA/" +
                                                              _vm.collectorStableVersion +
                                                              "/exe",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "vyoptacollector.exe"
                                                          ),
                                                        ]
                                                      ),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("td", [_vm._v(" ")]),
                                                    _vm._v(" "),
                                                    _c("td", [
                                                      _c(
                                                        "a",
                                                        {
                                                          attrs: {
                                                            href:
                                                              "/download/api/v1/collector/GA/" +
                                                              _vm.collectorStableVersion +
                                                              "/sh",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "vyoptacollector.sh"
                                                          ),
                                                        ]
                                                      ),
                                                    ]),
                                                  ])
                                                : _c("tr", [
                                                    _c("td", [
                                                      _c(
                                                        "a",
                                                        {
                                                          attrs: {
                                                            href:
                                                              "/download/api/v1/collector/RC/" +
                                                              _vm.collectorStableVersion +
                                                              "/exe",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "vyoptacollector.exe"
                                                          ),
                                                        ]
                                                      ),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("td", [_vm._v(" ")]),
                                                    _vm._v(" "),
                                                    _c("td", [
                                                      _c(
                                                        "a",
                                                        {
                                                          attrs: {
                                                            href:
                                                              "/download/api/v1/collector/RC/" +
                                                              _vm.collectorStableVersion +
                                                              "/sh",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "vyoptacollector.sh"
                                                          ),
                                                        ]
                                                      ),
                                                    ]),
                                                  ]),
                                              _vm._v(" "),
                                              _c("tr", [
                                                _c("td", [_vm._v(" ")]),
                                              ]),
                                              _vm._v(" "),
                                              _c("tr", [
                                                _c("td", [
                                                  _vm._v("Installation"),
                                                ]),
                                                _vm._v(" "),
                                                _c("td", [_vm._v(" ")]),
                                                _vm._v(" "),
                                                _c("td", [
                                                  _vm._v("Installation"),
                                                ]),
                                              ]),
                                              _vm._v(" "),
                                              _c("tr", [
                                                _c("td", [
                                                  _vm._v(
                                                    "Place alongside vyoptacollector.xml and run:"
                                                  ),
                                                  _c("br"),
                                                  _vm._v(" "),
                                                  _c("code", [
                                                    _vm._v(
                                                      "vyoptacollector.exe -install "
                                                    ),
                                                    _c("br"),
                                                    _vm._v(
                                                      " [-username <username> -password <password>]"
                                                    ),
                                                  ]),
                                                ]),
                                                _vm._v(" "),
                                                _c("td", [_vm._v(" ")]),
                                                _vm._v(" "),
                                                _c("td", [
                                                  _vm._v(
                                                    "Place alongside vyoptacollector.xml and run:"
                                                  ),
                                                  _c("br"),
                                                  _c("code", [
                                                    _vm._v(
                                                      "chmod 755 vyoptacollector.sh"
                                                    ),
                                                    _c("br"),
                                                    _vm._v(
                                                      "\n                            sudo ./vyoptacollector.sh -install "
                                                    ),
                                                    _c("br"),
                                                    _vm._v(
                                                      " [-username <username> -password <password>]"
                                                    ),
                                                  ]),
                                                ]),
                                              ]),
                                            ]),
                                          ]
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        {
                                          attrs: {
                                            xs12: "",
                                            "mb-10": "",
                                            "mt-5": "",
                                          },
                                        },
                                        [
                                          _c(
                                            "v-layout",
                                            { attrs: { wrap: "" } },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "subheading" },
                                                [
                                                  _c("b", [
                                                    _vm._v("Other versions:"),
                                                  ]),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.showOtherVersions
                                                ? _c(
                                                    "v-icon",
                                                    {
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          _vm.showOtherVersions =
                                                            !_vm.showOtherVersions
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "fal fa-chevron-up"
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              !_vm.showOtherVersions
                                                ? _c(
                                                    "v-icon",
                                                    {
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          _vm.showOtherVersions =
                                                            !_vm.showOtherVersions
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "fal fa-chevron-down"
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _vm.showOtherVersions
                                        ? _c(
                                            "v-flex",
                                            {
                                              staticStyle: {
                                                "margin-top": "-30px",
                                                "margin-bottom": "16px",
                                              },
                                              attrs: { xs12: "" },
                                            },
                                            [
                                              _c(
                                                "table",
                                                {
                                                  staticStyle: {
                                                    width: "100%",
                                                  },
                                                },
                                                [
                                                  _c("thead", [
                                                    _c("th"),
                                                    _vm._v(" "),
                                                    _c("th"),
                                                    _vm._v(" "),
                                                    _c("th"),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "tbody",
                                                    [
                                                      _vm._l(
                                                        _vm.collectorNewVersions,
                                                        function (v, i) {
                                                          return _c(
                                                            "tr",
                                                            {
                                                              key: v,
                                                              staticStyle: {
                                                                "line-height":
                                                                  "30px",
                                                              },
                                                            },
                                                            [
                                                              _c("td", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.removeBuild(
                                                                      v
                                                                    )
                                                                  )
                                                                ),
                                                              ]),
                                                              _vm._v(" "),
                                                              v.includes(".0.")
                                                                ? _c("td", [
                                                                    _c(
                                                                      "a",
                                                                      {
                                                                        attrs: {
                                                                          href:
                                                                            "/download/api/v1/collector/GA/" +
                                                                            v +
                                                                            "/exe",
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "vyoptacollector.exe"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ])
                                                                : _c("td", [
                                                                    _c(
                                                                      "a",
                                                                      {
                                                                        attrs: {
                                                                          href:
                                                                            "/download/api/v1/collector/RC/" +
                                                                            v +
                                                                            "/exe",
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "vyoptacollector.exe"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]),
                                                              _vm._v(" "),
                                                              v.includes(".0.")
                                                                ? _c("td", [
                                                                    _c(
                                                                      "a",
                                                                      {
                                                                        attrs: {
                                                                          href:
                                                                            "/download/api/v1/collector/GA/" +
                                                                            v +
                                                                            "/sh",
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "vyoptacollector.sh"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ])
                                                                : _c("td", [
                                                                    _c(
                                                                      "a",
                                                                      {
                                                                        attrs: {
                                                                          href:
                                                                            "/download/api/v1/collector/RC/" +
                                                                            v +
                                                                            "/sh",
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "vyoptacollector.sh"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]),
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                      _vm._v(" "),
                                                      _c("tr", [
                                                        _c("td", [_vm._v(" ")]),
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("tr", [
                                                        _c(
                                                          "td",
                                                          [
                                                            _c(
                                                              "v-btn",
                                                              {
                                                                staticClass:
                                                                  "btn btn-default",
                                                                attrs: {
                                                                  text: "",
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      _vm.oldVersions = true
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Archived Versions"
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("tr", [
                                                        _c("td", [_vm._v(" ")]),
                                                      ]),
                                                    ],
                                                    2
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "v-dialog",
                                        {
                                          attrs: { "max-width": "600px" },
                                          model: {
                                            value: _vm.oldVersions,
                                            callback: function ($$v) {
                                              _vm.oldVersions = $$v
                                            },
                                            expression: "oldVersions",
                                          },
                                        },
                                        [
                                          _c(
                                            "v-card",
                                            [
                                              _c("v-card-title", [
                                                _c(
                                                  "span",
                                                  { staticClass: "headline" },
                                                  [_vm._v("Archived Versions")]
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "v-card-text",
                                                [
                                                  _c(
                                                    "v-flex",
                                                    { attrs: { xs12: "" } },
                                                    [
                                                      _c(
                                                        "table",
                                                        {
                                                          staticStyle: {
                                                            width: "100%",
                                                          },
                                                        },
                                                        [
                                                          _c("thead", [
                                                            _c("th"),
                                                            _vm._v(" "),
                                                            _c("th"),
                                                            _vm._v(" "),
                                                            _c("th"),
                                                          ]),
                                                          _vm._v(" "),
                                                          _c(
                                                            "tbody",
                                                            [
                                                              _vm._l(
                                                                _vm.collectorOldVersions,
                                                                function (
                                                                  v,
                                                                  i
                                                                ) {
                                                                  return _c(
                                                                    "tr",
                                                                    {
                                                                      key: v,
                                                                      staticStyle:
                                                                        {
                                                                          "line-height":
                                                                            "30px",
                                                                        },
                                                                    },
                                                                    [
                                                                      _c("td", [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.removeBuild(
                                                                              v
                                                                            )
                                                                          )
                                                                        ),
                                                                      ]),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      v.includes(
                                                                        ".0."
                                                                      )
                                                                        ? _c(
                                                                            "td",
                                                                            [
                                                                              _c(
                                                                                "a",
                                                                                {
                                                                                  attrs:
                                                                                    {
                                                                                      href:
                                                                                        "/download/api/v1/collector/GA/" +
                                                                                        v +
                                                                                        "/exe",
                                                                                    },
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    "vyoptacollector.exe"
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                            ]
                                                                          )
                                                                        : _c(
                                                                            "td",
                                                                            [
                                                                              _c(
                                                                                "a",
                                                                                {
                                                                                  attrs:
                                                                                    {
                                                                                      href:
                                                                                        "/download/api/v1/collector/RC/" +
                                                                                        v +
                                                                                        "/exe",
                                                                                    },
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    "vyoptacollector.exe"
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                            ]
                                                                          ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      v.includes(
                                                                        ".0."
                                                                      )
                                                                        ? _c(
                                                                            "td",
                                                                            [
                                                                              _c(
                                                                                "a",
                                                                                {
                                                                                  attrs:
                                                                                    {
                                                                                      href:
                                                                                        "/download/api/v1/collector/GA/" +
                                                                                        v +
                                                                                        "/sh",
                                                                                    },
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    "vyoptacollector.sh"
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                            ]
                                                                          )
                                                                        : _c(
                                                                            "td",
                                                                            [
                                                                              _c(
                                                                                "a",
                                                                                {
                                                                                  attrs:
                                                                                    {
                                                                                      href:
                                                                                        "/download/api/v1/collector/RC/" +
                                                                                        v +
                                                                                        "/sh",
                                                                                    },
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    "vyoptacollector.sh"
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                            ]
                                                                          ),
                                                                    ]
                                                                  )
                                                                }
                                                              ),
                                                              _vm._v(" "),
                                                              _c("tr", [
                                                                _c("td", [
                                                                  _vm._v(" "),
                                                                ]),
                                                              ]),
                                                            ],
                                                            2
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "button",
                                        {
                                          staticClass: "btn btn-default",
                                          on: {
                                            click: function ($event) {
                                              return _vm.goPrev(step)
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n              Back\n            "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "button",
                                        {
                                          staticClass: "btn btn-primary",
                                          on: {
                                            click: function ($event) {
                                              return _vm.goNext(step)
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n              Done\n            "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }